import { styled } from 'styled-system/jsx'

const BellButton = styled('button', {
  base: {
    position: 'relative',
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    backgroundColor: 'transparent',
    color: 'quickpass.inkSoft',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, transform {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
      transform: 'translateY(-1px)',
    },
    _active: {
      transform: 'translateY(0)',
    },
  },
  variants: {
    hasUnread: {
      true: {
        borderColor: 'quickpass.primary',
        color: 'quickpass.primary',
      },
    },
  },
})

const BellGlyph = styled('span', {
  base: {
    fontSize: '18px',
    lineHeight: '1',
  },
})

const UnreadBadge = styled('span', {
  base: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    minWidth: '20px',
    height: '20px',
    paddingX: '6px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.warmth',
    color: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid',
    borderColor: 'quickpass.surface',
  },
})

export { BellButton, BellGlyph, UnreadBadge }
